import { System } from '@ecs/System';
import { UIElement } from '@components/UIElement';

export class UIUpdateSystem extends System {
  update(_deltaTime: number): void {
    // Get all UI elements that need updating
    const uiElements = this.getEntitiesWithComponents(UIElement);
    
    for (const entity of uiElements) {
      const uiElement = entity.getComponent(UIElement)!;
      
      // Only update if the element is marked as dirty
      if (!uiElement.isDirty) continue;
      
      // Special handling for different element types
      switch (uiElement.elementId) {
        case 'gameOverVisible':
          const gameOverElement = document.getElementById('gameOver');
          if (gameOverElement) {
            gameOverElement.style.display = uiElement.value === 'true' ? 'block' : 'none';
          }
          break;
          
        case 'gameOverTitle':
          const titleElement = document.getElementById('gameOverTitle');
          if (titleElement) {
            titleElement.textContent = String(uiElement.value);
          }
          break;
          
        case 'gameOverMessage':
          const messageElement = document.getElementById('gameOverMessage');
          if (messageElement) {
            messageElement.textContent = String(uiElement.value);
          }
          break;
          
        case 'gameOverButton':
          const buttonElement = document.querySelector('#gameOver .restart-btn') as HTMLButtonElement;
          if (buttonElement) {
            buttonElement.textContent = String(uiElement.value);
          }
          break;
          
        default:
          // Generic element update
          const element = document.getElementById(uiElement.elementId);
          if (element) {
            element.textContent = String(uiElement.value);
          }
          break;
      }
      
      // Mark as clean after update
      uiElement.isDirty = false;
    }
  }
}